module.exports = __webpack_public_path__ + "static/img/STK.d56e0e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/STK.svg
// module id = d7Db
// module chunks = 1